import { Card, CardContent, CardDescription, CardHeader, CardMeta, Icon, Image } from "semantic-ui-react";
import styles from './MainPage.module.css';
const Card1 = () => {

    return (
        <Card fluid className={styles.cardShadow}>
            <CardContent>
                <CardHeader><center>Tрюфели</center></CardHeader>
                <CardMeta>
                    <a href="/truffles"><Image src="./assets/trufflelogo.png" fluid centered /></a>
                    <span className='date'></span>
                </CardMeta>
            </CardContent>
        </Card>
    );
}

export default Card1